import { render, staticRenderFns } from "./MemoriesLanding.vue?vue&type=template&id=6c8a16e6&scoped=true"
import script from "./MemoriesLanding.vue?vue&type=script&lang=js"
export * from "./MemoriesLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8a16e6",
  null
  
)

export default component.exports